import { useEffect, useRef, useState } from "react";

interface ResponsiveTitleProps {
  children: React.ReactNode;
  className?: string;
}

export default function ResponsiveTitle({ children, className = "" }: ResponsiveTitleProps) {
  const ref = useRef<HTMLParagraphElement>(null);
  const [isWrapped, setIsWrapped] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const checkWrap = () => {
      const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
      const lines = el.clientHeight / lineHeight;
      setIsWrapped(lines > 1);
    };

    const observer = new ResizeObserver(checkWrap);
    observer.observe(el);
    window.addEventListener("resize", checkWrap);
    checkWrap();

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", checkWrap);
    };
  }, []);

  return (
    <p
      ref={ref}
      className={`transition-all duration-300 font-bold ${
        isWrapped ? "text-xl" : "text-2xl"
      } ${className}`}
    >
      {children}
    </p>
  );
}
